export default "__VITE_ASSET__4c53cd59__"